<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="区域">
                <a-select
                  v-model="queryParam.areaId"
                  placeholder="请选择区域"
                  style="width: 100%"
                  show-search
                  :filter-option="filterOption"
                  :loading="areaLoading"
                  allow-clear
                >
                  <a-select-option :value="0">全局配置</a-select-option>
                  <a-select-option v-for="area in areaList" :key="area.id" :value="area.id">
                    {{ area.areaName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="角色类型">
                <a-select placeholder="请选择" v-model="queryParam.roleType" style="width: 100%" allow-clear>
                  <a-select-option :value="1">平台</a-select-option>
                  <a-select-option :value="2">总代理</a-select-option>
                  <a-select-option :value="3">门店</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="是否启用">
                <a-select placeholder="请选择" v-model="queryParam.enable" style="width: 100%" allow-clear>
                  <a-select-option :value="1">是</a-select-option>
                  <a-select-option :value="0">否</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="是否继承">
                <a-select placeholder="请选择" v-model="queryParam.isInherit" style="width: 100%" allow-clear>
                  <a-select-option :value="1">是</a-select-option>
                  <a-select-option :value="0">否</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24" v-if="advanced">
              <a-form-item label="分销比例值">
                <a-input-number
                  v-model="queryParam.ratioValue"
                  placeholder="请输入分销比例值"
                  :min="0"
                  :precision="2"
                  style="width: 100%"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24" v-if="advanced">
              <a-form-item label="创建时间">
                <a-range-picker
                  v-model="createTimeValue"
                  format="YYYY-MM-DD"
                  :placeholder="['开始时间', '结束时间']"
                  @change="onChangeCreateTime"
                />
              </a-form-item>
            </a-col>
            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="handleAdd" v-hasPermi="['5dddf4b3ce70a80e088e7412b6f047e1c:0:c']">
          <a-icon type="plus" />新增
        </a-button>
        <!-- <a-button type="primary" @click="handleExport" v-hasPermi="['5dddf4b3ce70a80e088e7412b6f047e1e:0:e']">
          <a-icon type="download" />导出
        </a-button> -->
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="roleType" slot-scope="text, record">
          <a-tag :color="getRoleTypeColor(record.roleType)">
            {{ getRoleTypeText(record.roleType) }}
          </a-tag>
        </span>
        <span slot="enable" slot-scope="text, record">
          <template v-if="hasPermi(['5dddf4b3ce70a80e088e7412b6f047e1d:0:d'])">
            <a-popconfirm
              ok-text="是"
              cancel-text="否"
              @confirm="handleToggleEnable(record)"
              @cancel="cancelHandleStatus(record)"
            >
              <span slot="title">
                确认<b>{{ record.enable === 1 ? '禁用' : '启用' }}</b
                >该分销比例配置吗？
              </span>
              <a-switch checked-children="启用" un-checked-children="禁用" :checked="record.enable === 1" />
            </a-popconfirm>
          </template>
          <template v-else>
            <a-tag :color="record.enable === 1 ? 'green' : 'red'">
              {{ record.enable === 1 ? '是' : '否' }}
            </a-tag>
          </template>
        </span>
        <span slot="isInherit" slot-scope="text, record">
          <a-tag :color="record.isInherit === 1 ? 'green' : 'orange'">
            {{ record.isInherit === 1 ? '是' : '否' }}
          </a-tag>
        </span>
        <span slot="ratioValue" slot-scope="text, record">
          <span class="ratio-text">{{ record.ratioValue || 0 }}%</span>
        </span>
        <span slot="timeRange" slot-scope="text, record">
          {{ record.startTime || '--' }} ~ {{ record.endTime || '--' }}
        </span>
        <span slot="areaName" slot-scope="text, record">
          <span v-if="record.areaId === 0" class="global-tag">全局配置</span>
          <span v-else>{{ record.areaName || '--' }}</span>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="handleDetail(record)" v-hasPermi="['5dddf4b3ce70a80e088e7412b6f047e1q:0:q']">详情</a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
      <!-- 新增/编辑表单 -->
      <form-drawer ref="formDrawer" @success="handleAddSuccess" />
      <!-- 详情抽屉 -->
      <detail-drawer ref="detailDrawer" />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { fetchProportionList, toggleProportionEnable, fetchAreaList } from '@/api/profitSharing/proportion'
import moment from 'moment'
import { tableMixin } from '@/store/table-mixin'
import FormDrawer from './modules/FormDrawer'
import DetailDrawer from './modules/DetailDrawer'

export default {
  name: 'Proportion',
  components: {
    FormDrawer,
    DetailDrawer,
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      loading: false,
      total: 0,
      advanced: false,
      createTimeValue: [],
      areaList: [],
      areaLoading: false,
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        areaId: undefined,
        roleType: undefined,
        enable: undefined,
        isInherit: undefined,
        ratioValue: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        sortField: undefined,
        sortOrder: undefined,
      },
      columns: [
        {
          title: '区域名称',
          dataIndex: 'areaName',
          scopedSlots: { customRender: 'areaName' },
          align: 'center',
          width: 120,
        },
        {
          title: '角色类型',
          dataIndex: 'roleType',
          scopedSlots: { customRender: 'roleType' },
          align: 'center',
          width: 100,
        },
        {
          title: '分销比例值',
          dataIndex: 'ratioValue',
          scopedSlots: { customRender: 'ratioValue' },
          align: 'center',
          width: 120,
        },
        {
          title: '是否启用',
          dataIndex: 'enable',
          scopedSlots: { customRender: 'enable' },
          align: 'center',
          width: 100,
        },
        {
          title: '是否继承',
          dataIndex: 'isInherit',
          scopedSlots: { customRender: 'isInherit' },
          align: 'center',
          width: 100,
        },
        {
          title: '生效时间',
          scopedSlots: { customRender: 'timeRange' },
          align: 'center',
          width: 200,
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          align: 'center',
          width: 180,
        },
        {
          title: '操作',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
          width: 100,
        },
      ],
    }
  },
  computed: {
    hasPermi() {
      return (permissions) => {
        const allPermission = '*:*:*'
        const userPermissions = this.$store.getters && this.$store.getters.permissions
        if (!userPermissions || userPermissions.length === 0) {
          return false
        }
        if (permissions && permissions instanceof Array && permissions.length > 0) {
          return userPermissions.some((permission) => {
            return allPermission === permission || permissions.includes(permission)
          })
        }
        return false
      }
    },
  },
  methods: {
    loadAreaList() {
      this.areaLoading = true
      fetchAreaList({ status: 1 })
        .then((res) => {
          if (res.success && res.data) {
            this.areaList = res.data || []
          }
          this.areaLoading = false
        })
        .catch(() => {
          this.areaLoading = false
        })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    getRoleTypeText(roleType) {
      const map = {
        1: '平台',
        2: '总代理',
        3: '门店',
      }
      return map[roleType] || '--'
    },
    getRoleTypeColor(roleType) {
      const map = {
        1: 'blue',
        2: 'green',
        3: 'orange',
      }
      return map[roleType] || 'default'
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        areaId: undefined,
        roleType: undefined,
        enable: undefined,
        isInherit: undefined,
        ratioValue: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        sortField: undefined,
        sortOrder: undefined,
      }
      this.createTimeValue = []
      this.handleQuery()
    },
    onChangeCreateTime(e) {
      if (e && e.length === 2) {
        this.queryParam.createBeginTime = moment(e[0]).startOf('day').format('YYYY-MM-DD') + ' 00:00:00'
        this.queryParam.createEndTime = moment(e[1]).endOf('day').format('YYYY-MM-DD') + ' 23:59:59'
      } else {
        this.queryParam.createBeginTime = undefined
        this.queryParam.createEndTime = undefined
      }
    },
    getList() {
      this.loading = true
      fetchProportionList(this.queryParam)
        .then((res) => {
          this.list = res.data.records || []
          this.total = res.data.total || 0
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    handleAdd() {
      this.$refs.formDrawer.init()
    },
    handleAddSuccess() {
      this.getList()
    },
    handleToggleEnable(record) {
      const action = record.enable === 1 ? '禁用' : '启用'
      toggleProportionEnable({ id: record.id })
        .then((res) => {
          if (res.success) {
            this.$message.success(`${action}成功`)
            this.getList()
          } else {
            this.$message.error(res.message || `${action}失败`)
            // 刷新列表以恢复开关状态
            this.getList()
          }
        })
        .catch(() => {
          // 刷新列表以恢复开关状态
          this.getList()
        })
    },
    cancelHandleStatus(record) {
      // 取消操作时不需要做任何处理，开关会自动恢复原状态
    },
    handleDetail(record) {
      this.$refs.detailDrawer.init(record)
    },
    handleExport() {
      const that = this
      this.$confirm({
        title: '导出数据',
        content: '确认导出当前筛选条件下的所有数据吗？',
        onOk() {
          that.download(
            'upkeep/distributor/ratio/export',
            {
              ...that.queryParam,
            },
            `分销比例配置列表_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() {},
      })
    },
  },
  created() {
    this.loadAreaList()
    this.getList()
  },
}
</script>

<style lang="less" scoped>
.ratio-text {
  color: #1890ff;
  font-weight: 500;
  font-size: 14px;
}
.global-tag {
  color: #ff4d4f;
  font-weight: 500;
}
</style>
